<template>
  <article id="user-join" class="user-wrapper" v-if="isRendering">
    <div class="title" v-if="joinMode">회원가입</div>
    <div class="title" v-else>내 정보</div>
    <form class="input-wrapper" @submit.prevent="requestJoin">
      <!-- <div class="row">
        <div class="label-wrapper">
          <div class="label">label</div>
        </div>
        <div class="input-wrapper">
          <input class="input" />
        </div>
        <div class="button-area">
          <button class="button">button</button>
        </div>
      </div> -->
      <div class="row">
        <div class="label-wrapper">
          <div class="label">아이디</div>
        </div>
        <div class="input-wrapper">
          <input
            class="input"
            v-model="id"
            placeholder="4 ~ 32자리"
            ref="idInput"
            autocomplete="off"
            :disabled="!joinMode"
          />
        </div>
        <div class="button-area" v-if="joinMode">
          <button
            type="button duplicate"
            @click="idDuplicateCheck()"
            :disabled="idCheck"
          >
            중복확인
          </button>
        </div>
        <div class="button-area" v-else>
          <button
            type="button"
            @click="openLeaveModal()"
            :disabled="idCheck"
            class="leave"
          >
            탈퇴
          </button>
        </div>
      </div>
      <div class="row" v-if="!joinMode">
        <div class="label-wrapper">
          <div class="label">닉네임</div>
        </div>
        <div class="input-wrapper">
          <input
            class="input"
            v-model="nickname"
            placeholder="표시 이름 (2~16자)"
            maxlength="16"
            autocomplete="off"
          />
        </div>
        <div class="button-area"></div>
      </div>
      <div class="row">
        <div class="label-wrapper">
          <div class="label">비밀번호</div>
        </div>
        <div class="input-wrapper">
          <input
            class="input"
            placeholder="8자에서 24자리"
            ref="passwordInput"
            type="password"
            autocomplete="new-password"
            v-model="password"
          />
        </div>
        <div class="button-area"></div>
      </div>
      <div class="row">
        <div class="label-wrapper">
          <div class="label">비밀번호 확인</div>
        </div>
        <div class="input-wrapper">
          <input
            class="input"
            placeholder="8자에서 24자리"
            type="password"
            autocomplete="off"
            v-model="confirmPassword"
          />
        </div>
        <div class="button-area"></div>
      </div>
      <div class="row">
        <div class="label-wrapper">
          <div class="label">이름</div>
        </div>
        <div class="input-wrapper">
          <input
            class="input"
            placeholder="2자에서 32자"
            ref="nameInput"
            v-model="name"
          />
        </div>
        <div class="button-area"></div>
      </div>
      <div class="row">
        <div class="label-wrapper">
          <div class="label">생년월일</div>
        </div>
        <div class="input-wrapper">
          <input
            class="input"
            placeholder="2020-01-01"
            ref="birthInput"
            @input="formatBirthDate"
            maxlength="10"
            v-model="birth"
          />
        </div>
        <div class="button-area"></div>
      </div>
      <div class="row">
        <div class="label-wrapper">
          <div class="label">이메일 주소</div>
        </div>
        <div class="input-wrapper">
          <input
            class="input"
            placeholder="4자에서 32자리"
            ref="emailInput"
            v-model="email"
          />
        </div>
        <div class="button-area"></div>
      </div>
      <div class="row">
        <div class="description">
          * 이름/생년월일/이메일 주소는 계정정보 찾기에 사용됩니다.
        </div>
      </div>
      <div class="row">
        <div class="label-wrapper">
          <div class="label">성별</div>
        </div>
        <div class="radio-wrapper">
          <label class="custom-radio">
            <input
              type="radio"
              name="gender"
              value="0"
              v-model="selectedGender"
            />
            <span class="radio-custom"></span>
            선택 안 함
          </label>
          <label class="custom-radio">
            <input
              type="radio"
              name="gender"
              value="1"
              v-model="selectedGender"
            />
            <span class="radio-custom"></span>
            남자
          </label>
          <label class="custom-radio">
            <input
              type="radio"
              name="gender"
              value="2"
              v-model="selectedGender"
            />
            <span class="radio-custom"></span>
            여자
          </label>
        </div>
      </div>
      <div class="row kakao-row" v-if="!joinMode">
        <div class="label-wrapper">
          <div class="label">카카오 연동</div>
        </div>
        <div class="kakao-wrapper">
          <span class="kakao-status" :class="{ linked: kakaoLinked }">
            {{ kakaoLinked ? '연동됨' : '미연동' }}
          </span>
          <button
            v-if="!kakaoLinked"
            type="button"
            class="kakao-button link"
            @click="linkKakao()"
          >
            카카오 연동
          </button>
          <button
            v-else
            type="button"
            class="kakao-button unlink"
            @click="requestUnlinkKakao()"
          >
            연동 해제
          </button>
        </div>
      </div>
      <div class="row kakao-row" v-if="!joinMode && kakaoLinked">
        <div class="label-wrapper">
          <div class="label">로또 결과 알림</div>
        </div>
        <div class="kakao-wrapper">
          <label class="toggle-label">
            <input
              type="checkbox"
              :checked="kakaoLottoNotification"
              @change="toggleLottoNotification()"
            />
            <span>{{ kakaoLottoNotification ? '수신허용' : '수신거부' }}</span>
          </label>
        </div>
      </div>
      <div class="row" v-if="!joinMode">
        <div class="description kakao-description">
          * 카카오 연동 후 로또 결과 알림을 수신하면 추첨결과를 카카오톡으로 받을 수 있습니다.
        </div>
      </div>
      <div class="row" v-if="joinMode">
        <div class="label-wrapper">
          <div class="label">약관동의</div>
        </div>
        <div class="agree-wrapper">
          <label>
            <input type="checkbox" v-model="agreeToTerms" />
            <span>약관에 동의합니다.</span>
          </label>
          <a href="#" @click.prevent="openTerms">약관 보기</a>
        </div>
      </div>
    </form>
    <div class="button-area">
      <button class="button cancel" @click="cancel()">뒤로가기</button>
      <button class="button submit" @click="requestJoin()" v-if="joinMode">
        가입신청
      </button>
      <button class="button submit" @click="requestUpdate()" v-else>
        저장
      </button>
    </div>
    <div v-if="isLeaveModalOpen" class="modal">
      <div class="modal-content">
        <h2>회원 탈퇴</h2>
        <p>탈퇴를 원하시면 비밀번호를 입력하세요.</p>
        <p>즉시 모든 데이터가 삭제되며 복구되지 않습니다.</p>
        <input
          type="password"
          v-model="leavePassword"
          placeholder="비밀번호"
          class="input"
        />
        <div class="modal-buttons">
          <button @click="closeLeaveModal">취소</button>
          <button @click="confirmLeave">확인</button>
        </div>
      </div>
    </div>
  </article>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import UtilMixin from "@/common/mixins/UtilMixin";
import { JoinRequest, UserUpdateRequest } from "../class";
import { login, getKakaoAuthUrl, getKakaoStatus, unlinkKakao, toggleKakaoLottoNotification } from "../api";

export default defineComponent({
  setup() {
    const idInput = ref<HTMLInputElement | null>(null);
    const passwordInput = ref<HTMLInputElement | null>(null);
    const nameInput = ref<HTMLInputElement | null>(null);
    const birthInput = ref<HTMLInputElement | null>(null);
    const emailInput = ref<HTMLInputElement | null>(null);
    return { idInput, passwordInput, nameInput, birthInput, emailInput };
  },
  data() {
    return {
      isRendering: false,
      joinMode: true, // false: 내정보수정, true: 회원가입
      id: "",
      idCheck: false,
      password: "",
      confirmPassword: "",
      nickname: "",
      name: "",
      birth: "",
      email: "",
      selectedGender: 0,
      phone: "",
      memo: "",
      agreeToTerms: false,
      isLeaveModalOpen: false,
      leavePassword: "",
      kakaoLinked: false,
      kakaoLottoNotification: false,
    };
  },
  mixins: [UtilMixin],
  // components: { HoonyNavigation },
  watch: {
    // id가 변경될 때마다 idCheck를 false로 리셋
    id() {
      this.idCheck = false;
    },
  },
  methods: {
    cancel() {
      this.getRouterUtil().goBack();
    },
    async idDuplicateCheck() {
      if (this.getStringUtil().isEmpty(this.id)) {
        this.focusIdInput();
        return;
      }
      if (this.id.length < 4 || this.id.length > 32) {
        alert("ID는 4자리에서 32자리로 입력해주세요");
      }
      const result = await this.getApi().user().idDuplicateCheck(this.id);
      if (result.result) {
        alert("이미 사용중인 ID입니다.");
      } else {
        alert("사용가능한 ID입니다.");
        this.idCheck = true;
      }
    },
    formatBirthDate() {
      if (!this.birth) {
        this.birth = "";
        return;
      }
      let input = this.birth.replace(/\D/g, ""); // 숫자가 아닌 모든 문자를 제거
      if (input.length > 4) {
        input = input.slice(0, 4) + "-" + input.slice(4);
      }
      if (input.length > 7) {
        input = input.slice(0, 7) + "-" + input.slice(7);
      }
      this.birth = input;
    },
    focusIdInput() {
      alert("ID를 입력해주세요");
      if (this.idInput) {
        this.idInput.focus();
      }
    },
    focusPasswordInput() {
      // alert("비밀번호를 확인해주세요");
      this.passwordClear();
      if (this.passwordInput) {
        this.passwordInput.focus();
      }
    },
    passwordClear() {
      this.password = "";
      this.confirmPassword = "";
    },
    focusNameInput() {
      if (this.nameInput) {
        this.nameInput.focus();
      }
    },
    focusBirthInput() {
      if (this.birthInput) {
        this.birthInput.focus();
      }
    },
    focusEmailInput() {
      if (this.emailInput) {
        this.emailInput.focus();
      }
    },
    openTerms() {
      this.getRouterUtil().open("/user/terms");
    },
    inputFormValidate() {
      if (this.joinMode && !this.idCheck) {
        alert("ID 중복체크를 진행해주세요");
        return false;
      }
      if (this.joinMode) {
        if (this.password.length < 8 || this.password.length > 24) {
          alert("비밀번호는 8자리에서 24자리로 입력해주세요");
          this.focusPasswordInput();
          return false;
        }
        if (this.password != this.confirmPassword) {
          alert("비밀번호가 일치하지 않습니다. 다시 입력해 주세요");
          this.focusPasswordInput();
          return false;
        }
      } else {
        // 내정보 수정시에는 비밀번호 입력한 경우에만 체크
        if (this.password.length > 0) {
          if (this.password.length < 8 || this.password.length > 24) {
            alert("비밀번호는 8자리에서 24자리로 입력해주세요");
            this.focusPasswordInput();
            return false;
          }
          if (this.password != this.confirmPassword) {
            alert("비밀번호가 일치하지 않습니다. 다시 입력해 주세요");
            this.focusPasswordInput();
            return false;
          }
        }
      }

      if (!this.joinMode) {
        const nn = (this.nickname || "").trim();
        if (nn.length < 2 || nn.length > 16) {
          alert("닉네임은 2자에서 16자로 입력해주세요");
          return false;
        }
      }

      if (this.name.length < 2 || this.name.length > 32) {
        alert("이름은 2자리에서 32자리로 입력해주세요");
        this.focusNameInput();
        return false;
      }

      if (this.birth.length < 8) {
        alert("생일은 2001 - 01 - 01 형식으로 입력해주세요");
        this.focusBirthInput();
        return false;
      }

      if (this.email.length < 4 || this.email.length > 32) {
        alert("이메일 주소는 4자리에서 32자리로 입력해주세요");
        this.focusEmailInput();
        return false;
      }
      if (!this.getStringUtil().isValidEmail(this.email)) {
        alert("이메일 형식을 확인해주세요");
        this.focusEmailInput();
        return false;
      }
      if (this.joinMode && !this.agreeToTerms) {
        alert("약관에 동의해주세요");
      }
      return true;
    },

    async requestJoin() {
      console.log("------------- join reuqest");
      if (!this.inputFormValidate()) {
        return false;
      }

      const request = new JoinRequest();
      request.init(
        this.id,
        this.password,
        this.name,
        this.birth.replace(/-/g, ""),
        this.email,
        this.selectedGender
      );

      const result = await this.getApi().user().join(request);
      if (result.success) {
        alert("회원가입이 완료되었습니다.\n로그인 후 이용하시기 바랍니다");
        this.getRouterUtil().moveTo("/user/login");
      } else {
        console.log("fail result : ", result);
      }
    },
    async requestUpdate() {
      console.log("------------- update reuqest");
      if (!this.inputFormValidate()) {
        return false;
      }
      console.log("pass");
      const request = new UserUpdateRequest();
      request.setRequest(
        this.password,
        this.nickname,
        this.name,
        this.birth.replace(/-/g, ""),
        this.email,
        this.selectedGender,
        // this.phone,
        this.memo
      );
      const id = this.getCore().getLoginInfo().id;
      const result = await this.getApi().user().updateUserInfo(id, request);
      if (result.result) {
        alert("내 정보가 저장되었습니다.");
        this.passwordClear();
      } else {
        console.log("user update fail : ", result);
      }
    },
    async leave() {
      //
    },

    openLeaveModal() {
      this.isLeaveModalOpen = true;
    },
    closeLeaveModal() {
      this.isLeaveModalOpen = false;
      this.leavePassword = "";
    },
    async confirmLeave() {
      const id = this.getCore().getLoginInfo().id;
      // const input = prompt(
      //   "탈퇴하면 모든 데이터가 즉시 삭제됩니다.\n 그래도 원하시는 경우 비밀번호를 입력해주세요"
      // );
      if (!this.leavePassword) {
        alert("비밀번호를 입력해주세요.");
        return;
      }
      if (this.leavePassword) {
        //
        const request = {
          currentPassword: this.leavePassword,
        };
        const result = await this.getApi().user().leave(request);
        console.log("result : ", result);
        if (result.result) {
          alert("회원탈퇴가 정상처리되었습니다.");
          this.getCore().logout();
          this.getRouterUtil().moveTo("/");
        }
      } else {
        alert("아이디가 일치하지 않습니다.");
      }
    },

    async linkKakao() {
      try {
        const result = await getKakaoAuthUrl();
        if (result && result.authUrl) {
          window.location.href = result.authUrl;
        }
      } catch (e) {
        console.error("카카오 인증 URL 조회 실패", e);
      }
    },
    async checkKakaoStatus() {
      try {
        const result = await getKakaoStatus();
        if (result) {
          this.kakaoLinked = result.linked;
          this.kakaoLottoNotification = result.lottoNotification;
        }
      } catch (e) {
        console.error("카카오 상태 조회 실패", e);
      }
    },
    async toggleLottoNotification() {
      try {
        const result = await toggleKakaoLottoNotification();
        if (result) {
          this.kakaoLottoNotification = result.lottoNotification;
        }
      } catch (e) {
        console.error("알림 설정 변경 실패", e);
        alert("알림 설정 변경에 실패했습니다.");
      }
    },
    async requestUnlinkKakao() {
      if (!confirm("카카오 연동을 해제하시겠습니까?\n로또 결과 알림을 받을 수 없게 됩니다.")) {
        return;
      }
      try {
        await unlinkKakao();
        this.kakaoLinked = false;
        this.kakaoLottoNotification = false;
        alert("카카오 연동이 해제되었습니다.");
      } catch (e) {
        console.error("카카오 연동 해제 실패", e);
        alert("카카오 연동 해제에 실패했습니다.");
      }
    },
    handleKakaoCallback() {
      const urlParams = new URLSearchParams(window.location.search);
      const kakaoResult = urlParams.get("kakao");
      if (kakaoResult === "success") {
        alert("카카오 연동이 완료되었습니다.");
        this.kakaoLinked = true;
        // URL에서 파라미터 제거
        window.history.replaceState({}, document.title, window.location.pathname);
      } else if (kakaoResult === "fail") {
        alert("카카오 연동에 실패했습니다. 다시 시도해주세요.");
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    },
    async setMyInfoPage() {
      const loginInfo = this.getCore().getLoginInfo();
      const result = await this.getApi().user().getUserDetailInfo(loginInfo.id);
      this.id = result.id;
      this.nickname = result.nickname;
      this.name = result.name;
      this.birth = result.birth;
      this.email = result.email;
      this.selectedGender = result.gender;
      this.formatBirthDate();
      this.isRendering = true;
      // 카카오 상태 체크
      this.checkKakaoStatus();
      // 카카오 콜백 파라미터 처리
      this.handleKakaoCallback();
    },
    async sessionCheck() {
      const isLogin = await this.getCore().sessionCheck();
      if (isLogin) {
        this.setMyInfoPage();
        this.joinMode = false;
      } else {
        this.isRendering = true;
        this.joinMode = true;
      }
    },
  },
  created() {
    console.log("[UserInfoPage] created");
    this.sessionCheck();
    window.scrollTo(0, 0);
  },
});
</script>

<style lang="scss" scoped></style>
